<template>
  <section
    v-if="props.data"
    class="galleryBlocks"
    :class="[props.data.parentClasses, props.data.parentStyle ? props.data.parentStyle : 'defaultStyle']"
  >
    <div class="container col">
      <div class="row justify-content-center">
        <div class="col s12 m9 l7 xl6">
          <div class="section-heading lg center-align">
            <h2 v-if="props.data.title">
              {{ props.data.title }}
            </h2>
            <div
              v-if="props.data.descr"
              v-html="convertToHtml(props.data.descr)"
            ></div>
          </div>
        </div>

        <div class="galleryBlocks__items col s12 m12 l12 xl12">
          <div class="row">
            <div
              v-for="col in props.data.items"
              :key="col"
              class="galleryBlocks__col col"
              :class="col.classes"
            >
              <div class="row">
                <template v-for="item, i in col.list">
                  <div
                    v-if="item"
                    :key="item"
                    class="galleryBlocks__item col"
                    :class="[item.classes, { onlyBlocks: props.data.onlyBlocks}]"
                    @click="() => {
                      if (!props.data.onlyBlocks) {
                        visibleDialog = true
                        currentItem = item
                      }
                    }"
                  >
                    <nuxt-picture
                      :img-attrs="{class: 'responsive-img', alt: item.alt + ' ' + i++}"
                      :src="item.image"
                      :placeholder="[100, 50, 10]"
                      sizes=""
                      loading="lazy"
                    />
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Dialog
      v-model:visible="visibleDialog"
      maximizable
      modal
      :header="currentItem.title"
      :style="{ width: '90%', maxWidth: '1400px' }"
      :dismissable-mask="true"
      :draggable="false"
    >
      <div class="galleryModalContent w-full">
        <div class="flex space-x-4">
          <div class="galleryModalContent__image w-1/2">
            <nuxt-picture
              :img-attrs="{class: 'responsive-img', alt: currentItem.alt + ' 0'}"
              :src="currentItem.image"
              width="550"
              height="550"
              :placeholder="[100, 50, 10]"
              sizes=""
              loading="lazy"
            />
          </div>
          <div class="galleryModalContent__content w-1/2">
            <strong
              v-if="currentItem.title"
              class="h2"
            >{{ currentItem.title }}</strong>
            <div
              v-if="currentItem.descr"
              v-html="convertToHtml(currentItem.descr)"
            ></div>
          </div>
        </div>

        <div class="galleryModalContent__slider w-full pt-4">
          <div class="slider-nav galleryModalContent__slider__navigation">
            <button
              class="galleryModalContent__slider__navigation__prev swiper-arrow prev !relative"
              :aria-label="$t('preview')"
              type="button"
            >
              <span class="icon icon-left-arrow"></span>
            </button>
            <button
              class="galleryModalContent__slider__navigation__next swiper-arrow next !relative"
              :aria-label="$t('next')"
              type="button"
            >
              <span class="icon icon-right-arrow"></span>
            </button>
          </div>

          <ClientOnly>
            <Swiper
              :modules="[Pagination, Navigation]"
              :slides-per-view="4"
              :loop="false"
              :space-between="16"
              :navigation="{
                prevEl: '.galleryModalContent__slider__navigation__prev',
                nextEl: '.galleryModalContent__slider__navigation__next'
              }"
              :pagination="{
                clickable: true
              }"
              :breakpoints="{
                0: {
                  slidesPerView: 2
                },
                480: {
                  slidesPerView: 2
                },
                650: {
                  slidesPerView: 3
                },
                993: {
                  slidesPerView: 4
                }
              }"
            >
              <SwiperSlide
                v-for="item2, i in currentItem.images"
                :key="item2"
                class="galleryModalContent__slider__item"
              >
                <nuxt-picture
                  :img-attrs="{class: 'responsive-img', alt: item2.alt + ' ' + i++}"
                  :src="item2.image"
                  width="360"
                  height="240"
                  :placeholder="[100, 50, 10]"
                  sizes=""
                  loading="lazy"
                />
              </SwiperSlide>
            </Swiper>
          </ClientOnly>
        </div>
      </div>
    </Dialog>
  </section>
</template>

<script setup>
import { Pagination, Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'

const visibleDialog = ref(false)
const currentItem = ref(false)

/**
* Props
*/
const props = defineProps({
  data: {
    type: [Object],
    default: null
  }
})
</script>

<style lang="scss" scoped>
.galleryBlocks {
  &__item {
    margin-bottom: 1.875rem;
    cursor: pointer;
    &.onlyBlocks {
      cursor: default;
    }
    &:deep(img) {
      width: 100%;
      box-shadow: 0 2px 5px rgba(0,0,0,.2);
      border-radius: 5px;
    }
    @media only screen and (max-width: 600px) {
      margin-bottom: 1rem;
    }
  }
}

.galleryModalContent {
  &__image {
    max-width: 300px;
    margin: -6rem 0 0 0;
    &:deep(img) {
      box-shadow: 0 2px 5px rgba(0,0,0,.2);
      border-radius: 4px;
    }
  }
  &__slider {
    position: relative;
    padding-top: 2rem;
    .swiper {
      padding: 0;
      &:deep(.swiper-pagination) {
        display: flex!important;
      }
      &:deep(.swiper-pagination-bullet) {
        width: 1.5rem;
        height: 1rem;
        &:before {
          width: .425rem;
          height: .425rem;
        }
      }
    }
    &__navigation {
      .prev,
      .next {
        position: absolute;
        top: calc(50% - 2.1rem);
        display: flex;
        justify-content: center;
        align-items: center;
        width: 2rem;
        height: 4rem;
        padding: 0;
        box-shadow: none;
        border: none;
        &.swiper-button-disabled {
          display: none;
        }
      }
      &__prev {
        left: 0;
      }
      &__next {
        right: 0;
      }
    }
  }
}
</style>
